import { useCallback, useEffect, useState } from 'react'

import useCallbackRef from 'app/common/hooks/useCallbackRef'

import PlainDropdown from './plain-dropdown'
import PlainDropdownDefitem from './plain-dropdown-defitem'

type Item = { ID: string; title: string } | { id: string; title: string }

const getID = (item: Item) => {
  if ('ID' in item) {
    return item.ID
  }
  return item.id
}

type Props<T extends Item> = {
  id: string
  labelId?: string
  className?: string
  itemsContainerClassName?: string
  value?: string
  defaultValue?: string | null
  items: Array<T>
  disabled?: boolean
  loading?: boolean
  keepSelectedElementInList?: boolean
  onChange?: (ID: string, elementId: string) => void | Promise<void>
  error?: boolean
}

export function PlainDropdownSimplified<T extends Item>({
  id,
  labelId,
  className,
  itemsContainerClassName,
  value,
  defaultValue = null,
  items,
  disabled,
  loading,
  keepSelectedElementInList,
  onChange,
  error,
}: Props<T>) {
  const [currentValue, setCurrentValue] = useState(defaultValue)

  const onChangeRef = useCallbackRef(onChange)

  const handleChange = useCallback(
    ({ id: ID }: { id: string }) => {
      setCurrentValue(ID)
      onChangeRef.current?.(ID, id)
    },
    [onChangeRef, id],
  )

  useEffect(() => {
    setCurrentValue(value || '')
  }, [value, loading])

  useEffect(() => {
    setCurrentValue(defaultValue || '')
  }, [defaultValue])

  return (
    <PlainDropdown
      id={id}
      labelId={labelId}
      className={className}
      itemsContainerClassName={itemsContainerClassName}
      onChange={handleChange}
      placeholder={<PlainDropdownDefitem id="placeholder">{'Не указано'}</PlainDropdownDefitem>}
      disabled={disabled}
      loading={loading}
      keepSelectedElementInList={keepSelectedElementInList}
      errored={error}
      defaultSkin
    >
      {items.map((props: T) => {
        const ID = getID(props)
        const { title } = props

        return (
          <PlainDropdownDefitem id={ID} key={ID} disabled={disabled} selected={ID === currentValue}>
            {title}
          </PlainDropdownDefitem>
        )
      })}
    </PlainDropdown>
  )
}
